import React, { useEffect, useRef } from "react";
import "../styles/Artikel.css";
import Artikel1 from "../assets/Artikel-1.jpg";
import Artikel2 from "../assets/Artikel-2.jpg";
import Artikel3 from "../assets/Artikel-3.jpg";

const Artikel = () => {
    const artikelRef = useRef(null);

    useEffect(() => {
        const items = artikelRef.current.querySelectorAll(".artikel-item");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                    }
                });
            },
            { threshold: 0.2 }
        );

        items.forEach((item) => observer.observe(item));

        return () => observer.disconnect();
    }, []);

    const articles = [
        {
            id: 1,
            title: "[𝗖𝗢𝗠𝗜𝗡𝗚 𝗦𝗢𝗢𝗡🔊: 16 Hari Anti Kekerasan terhadap Perempuan]",
            image: Artikel1,
            link: "https://www.instagram.com/p/DCs8k47zibc/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
        },
        {
            id: 2,
            title: "[𝗖𝗢𝗠𝗜𝗡𝗚 𝗦𝗢𝗢𝗡🔊: 16 Hari Anti Kekerasan terhadap Perempuan]",
            image: Artikel2,
            link: "https://www.instagram.com/p/DCs8iv6z65R/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
        },
        {
            id: 3,
            title: "[𝗖𝗢𝗠𝗜𝗡𝗚 𝗦𝗢𝗢𝗡🔊: 16 Hari Anti Kekerasan terhadap Perempuan]",
            image: Artikel3,
            link: "https://www.instagram.com/p/DCs8eYXTMBR/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
        },
    ];

    return (
        <section id="artikel" className="artikel" ref={artikelRef}>
            <h2>Artikel</h2>
            <div className="artikel-list">
                {articles.map((article) => (
                    <div className="artikel-item" key={article.id}>
                        <img src={article.image} alt={article.title} />
                        <p>{article.title}</p>
                        <a
                            href={article.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="lihat-selengkapnya"
                        >
                            Lihat Selengkapnya
                        </a>
                    </div>
                ))}
            </div>
            <a
                href="https://www.instagram.com/pemberdayaanperempuanub/"
                target="_blank"
                rel="noopener noreferrer"
                className="cek-artikel-lainnya-btn"
            >
                Cek Artikel Lainnya →
            </a>
        </section>
    );
};

export default Artikel;
